import { emitter } from '@/emitter'

let referer = location.href

addEventListener('turbo:before-visit', () => {
    referer = location.href
})

addEventListener('turbo:load', () => {
    if (typeof ym === 'function') {
        ym(86985182, 'hit', location.href, {
            title: document.title,
            referer: referer
        });
    }
})

emitter.on('ym:reachGoal', (name) => {
    if (typeof ym === 'function') {
        ym(86985182,'reachGoal', name)
    }
})